import {
  MutationStatus,
  UseMutateAsyncFunction,
  useMutation
} from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  UpdateTemplateResponseRequestObjectType,
  UpdateTemplateResponseResponseType
} from '../../../services/NwApplicationServices/APIService/types';

import { useNwApplicationService } from '../useNwApplicationService';

interface UseUpdateTemplateResponseInterface {
  updateTemplateResponseApi: UseMutateAsyncFunction<
    UpdateTemplateResponseResponseType,
    unknown,
    UpdateTemplateResponseRequestObjectType,
    unknown
  >;
  error: string;
  status: MutationStatus;
}

const useUpdateTemplateResponse = (): UseUpdateTemplateResponseInterface => {
  const { nwApplicationService } = useNwApplicationService();

  const updateTemplateResponse = (
    requestObject: UpdateTemplateResponseRequestObjectType
  ) => {
    return nwApplicationService.updateTemplateResponse(requestObject);
  };

  const { mutateAsync, error, status } = useMutation(updateTemplateResponse, {
    mutationKey: ['updateTemplateResponseApi']
  });

  return {
    updateTemplateResponseApi: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
};

export { useUpdateTemplateResponse };
